/* tslint:disable */
/* eslint-disable */
/**
 * RoadFootage.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 */
export const UserFileAttentionFilter = {
    NeedsAttention: 'NeedsAttention',
    Failed: 'Failed',
    Threat: 'Threat',
    Processing: 'Processing',
    PendingScan: 'PendingScan',
    Queued: 'Queued'
};
export function UserFileAttentionFilterFromJSON(json) {
    return UserFileAttentionFilterFromJSONTyped(json, false);
}
export function UserFileAttentionFilterFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function UserFileAttentionFilterToJSON(value) {
    return value;
}
